module.exports = __webpack_public_path__ + "static/media/cc_visa.2bcbcd90.svg";